import Header from "../../../components/Header"
import CustomerFeedback from "../../../components/inner-page/CustomerFeedback"
import EventTypes from "../../../components/inner-page/EventTypes"
import FeatureCards from "../../../components/inner-page/FeatureCards"
import Hero from "../../../components/inner-page/Hero"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"
import MainFeaturesSection from "../../../components/inner-page/MainFeaturesSection"
import Layout from "../../../components/Layout"
import { mainFeatures } from "../../../data/mainFeatureData"

export function Index() {
  return (
    <Layout
      title="Corporate Event Solutions - AI Platform for Enterprise"
      description="Discover how Fortune 500 companies use Premagic for impactful corporate events. AI-powered engagement & photo distribution."
      keywords={[
        "corporate event platform, enterprise event solutions, Fortune 500 events, corporate AI events, business event technology, enterprise photo sharing, corporate conference platform, company event management, B2B event solutions, corporate networking events, enterprise event engagement, business event AI, corporate MICE solutions, company meeting platform, executive event technology",
      ]}
    >
      <Header />
      <Hero />
      <FeatureCards />
      <MainFeaturesSection features={mainFeatures} />
      <EventTypes />
      <CustomerFeedback />
      <MagicWithUs />
    </Layout>
  )
}

export default Index
